import type { PaginatedResponse } from "@/features/profiles/services/profiles/types";

export const CONTRACT_STATUSES = [
  'DRAFT',
  'PENDING_SIGNATURE',
  'SIGNED',
  'EXPIRED',
  'CANCELLED',
  'active',
  'expiring',
  'expired',
] as const;

export type ContractStatus = (typeof CONTRACT_STATUSES)[number];

export interface ContractFile {
  id: string;
  fileName: string;
  fileUrl: string;
  fileSize: number;
  mimeType: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Creator {
  id: string;
  name: string;
  email: string;
  username?: string;
  avatar?: string | null;
}

export interface Contract {
  id: string;
  creatorId: string;
  creator: Creator;
  startDate: string; // ISO date
  endDate: string; // ISO date
  status: ContractStatus;
  files: ContractFile[];
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export type ContractSortBy = 'endDate' | 'startDate' | 'createdAt';
export type ContractOrder = 'asc' | 'desc';

export interface GetContractsParams {
  page?: number;
  limit?: number;
  status?: ContractStatus | 'all';
  creatorId?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  includeDeleted?: boolean;
  sortBy?: ContractSortBy;
  order?: ContractOrder;
}

export type PaginatedContractsResponse = PaginatedResponse<Contract>;

export interface CreateContractPayload {
  creatorId: string;
  startDate: string;
  endDate: string;
  status?: ContractStatus;
  file?: File;
}

export interface UpdateContractPayload {
  creatorId?: string;
  startDate?: string;
  endDate?: string;
  status?: ContractStatus;
  file?: File;
}

// Aliases para compatibilidade
export type CreateContractData = CreateContractPayload;
export type UpdateContractData = UpdateContractPayload;
